/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/column_headers.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    columnHeadersModule
} from "../../../grids/grid_core/column_headers/m_column_headers";
import gridCore from "../m_core";
export var ColumnHeadersView = columnHeadersModule.views.columnHeadersView;
gridCore.registerModule("columnHeaders", columnHeadersModule);
